import styled from 'styled-components';
import { colors } from '@podiumhq/podium-ui';

export const Logo = styled.div`
  margin: 0 0 84px auto;
  text-align: center;
  transition: all 200ms 200ms;
  white-space: nowrap;
`;

export const ConnectWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 40px;
`;

export const Dots = styled.div`
  display: flex;
  margin: 20px;
  justify-content: center;
`;

export const ImageWrapper = styled.img`
  width: 97.3px;
  height: 97.3px;
  border-radius: 2.8px;
`;

export const ImagePlaceholder = styled.div`
  width: 97.3px;
  height: 97.3px;
  border-radius: 2.8px;
  background-color: ${colors.whiteSmoke};
`;

export const Text = styled.div`
  color: ${colors.jumbo};
  font-size: 16px;
  font-weight: normal;
  line-height: 32px;
  padding-bottom: 24px;
  text-align: center;
`;

export const ScopesWrapper = styled.div`
  color: ${colors.jumbo};
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  padding: 20px 24px;
  border: 1px solid ${colors.mystic};
  margin-bottom: 40px;
  border-radius: 8px;
`;

export const ScopesTitle = styled.div`
  font-weight: 600;
  padding-bottom: 16px;
`;

export const Scope = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 16px;
  font-size: 16px;

  > span {
    padding-left: 8px;
  }
`;

export const TextLoading = styled.div`
  height: 64px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`;
